/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionDataRequestTypeSchema = z.enum(['select', 'text', 'open_text', 'file', 'datetime'])

export type QuestionDataRequestTypeSchema = z.infer<typeof questionDataRequestTypeSchema>
